"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_xdr_1 = require("js-xdr");
function serializeHyper(value) {
    return value.toString();
}
function serializeEnum({ name }) {
    return name;
}
function serializeUnion(union) {
    const serialized = {
        _type: null,
    };
    if (union.switch() instanceof js_xdr_1.Enum) {
        serialized._type = union.switch().name;
    }
    else {
        serialized._type = union.switch();
    }
    const value = serialize(union.armType(), union.value());
    let arm = union.arm();
    const unionConst = union.constructor;
    // TODO: Add helper function to union to know if current value is the default arm.
    if (!unionConst._switches.has(union.switch()) && !!unionConst._defaultArm) {
        arm = "default";
    }
    if (value !== undefined) {
        serialized[arm] = value;
    }
    return serialized;
}
function serializeString(value) {
    if (typeof value === "string") {
        return value;
    }
    else {
        return value.toString("utf8");
    }
}
function serializeStruct(struct) {
    const structConstructor = struct.constructor;
    return structConstructor._fields.reduce((json, [name, type]) => {
        json[name] = serialize(type, struct._attributes[name]);
        return json;
    }, {});
}
exports.serializeStruct = serializeStruct;
function serialize(xdrType, value) {
    if (value instanceof js_xdr_1.Hyper || value instanceof js_xdr_1.UnsignedHyper) {
        return serializeHyper(value);
    }
    else if (value instanceof js_xdr_1.Enum) {
        return serializeEnum(value);
    }
    else if (xdrType instanceof js_xdr_1.Opaque || xdrType instanceof js_xdr_1.VarOpaque) {
        // assume value it's buffer like
        return value.toString("base64");
    }
    else if (xdrType instanceof js_xdr_1.Array || xdrType instanceof js_xdr_1.VarArray) {
        return value.map((val) => serialize(xdrType._childType, val));
    }
    else if (value instanceof Array) {
        let childType;
        if (value.length > 0) {
            // We are receiving a JavaScript array, let's try to guess its elements type
            childType = value[0].constructor;
        }
        return value.map((val) => serialize(childType, val));
    }
    else if (xdrType instanceof js_xdr_1.String) {
        return serializeString(value);
    }
    else if (value instanceof js_xdr_1.Struct) {
        return serializeStruct(value);
    }
    else if (value instanceof js_xdr_1.Union) {
        return serializeUnion(value);
    }
    else {
        return value;
    }
}
exports.default = serialize;
//# sourceMappingURL=serializer.js.map